export const isJWT = (jwt) => {
    if (!jwt) return false;
    if (!jwt.includes('.')) return false;

    const jwtSplitted = jwt.split('.');
    if (jwtSplitted.length !== 3) return false;
    
    return true;
}

export const parseJwt = (token) => {
    if (!isJWT(token)) return {};

    try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (error) {
        localStorage.removeItem(`token-${process.env.REACT_APP_APPID}`);
        return {};
    }
}
